import { axiosInstanceIntegraciones } from '../../../utils/axiosGlobalUtils'
import { AxiosResponse } from 'axios'
import { Novedad, NovedadesResponse } from '../types/responses-novedades'

export const GetNovedades = async (tenant: string, codLocal: string, idCategoria: number | string = '', searchText = '') =>
  (await axiosInstanceIntegraciones.get(
    `/${tenant}/locales/${codLocal}/novedades?idCategoria=${idCategoria}&searchText=${searchText}`
  )) as AxiosResponse<NovedadesResponse>

export const UpdateNovedad = async (tenant: string, codLocal: string, novedad: Partial<Novedad>) =>
  (await axiosInstanceIntegraciones.put(`/${tenant}/locales/${codLocal}/novedades`, novedad)) as AxiosResponse<any>

export const RejectNovedad = async (tenant: string, codLocal: string, int_externalId: number) =>
  (await axiosInstanceIntegraciones.delete(`/${tenant}/locales/${codLocal}/novedades`, {
    data: [{ int_externalId }]
  })) as AxiosResponse<any>

export const UpdateNovedades = async (tenant: string, codLocal: string, novedad: Partial<Novedad>[]) =>
  (await axiosInstanceIntegraciones.put(`/${tenant}/locales/${codLocal}/novedades`, novedad)) as AxiosResponse<any>

export const RejectNovedades = async (tenant: string, codLocal: string, int_externalId: number[]) =>
  (await axiosInstanceIntegraciones.delete(`/${tenant}/locales/${codLocal}/novedades`, {
    data: int_externalId
  })) as AxiosResponse<any>
